import gql from 'graphql-tag';

export const getWaterTankMonitor = gql`
  query waterTankMonitor($deviceId: Int!) {
    waterTankMonitor(deviceId: $deviceId) {
      waterTankMonitor {
        id
        name
        waterTankMonitorUrl
      }
    }
  }
`;

export const getCondominiumWaterTankMonitors = gql`
  query condominiumWaterTankMonitors($condominiumPersonContextId: Int!) {
    condominiumWaterTankMonitors(
      condominiumPersonContextId: $condominiumPersonContextId
    ) {
      waterTankMonitors {
        id
        name
        waterTankMonitorUrl
      }
    }
  }
`;
